module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_alvesta-074041ed27bcb4c89e6d543f367c7040.png";